import { format } from 'date-fns';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import Looading from '../../Shared/Looading/Looading';
import AppointmentOption from '../AppointmentOption/AppointmentOption';
import BookingModal from '../BookingModal/BookingModal';

const AvailavelAppointment = ({ selectedDate, setSelectedDate}) => {

    const date = format(selectedDate, 'PP');

    const [treatment, setTreatment] = useState(null)

    const { data: appointmentoptinos = [], refetch,isLoading } = useQuery(

        {
            queryKey: ['appointmentoptinos', date],

            queryFn: async () => {
                const res = await fetch(`https://denticare-server-sumonhasan55.vercel.app/appointmentOptions?date=${date}`);
                const data = await res.json()
                return data
            }
        }
    );
if(isLoading){
    return <Looading></Looading>
}


    return (
        <div>

            <div className="">
                <p className='text-info text-bold lg:text-4xl text-center'>Available Appointment on:{format(selectedDate, 'PP')}</p>
            </div>
            <div className="lg:grid grid-cols-3 gap-4">
                {
                    appointmentoptinos?.map(option => <AppointmentOption
                        key={option._id}
                        option={option}
                        setTreatment={setTreatment}
                    >
                    </AppointmentOption>)

                }
            </div>
            {
                treatment && <BookingModal
                    treatment={treatment}
                    setTreatment={setTreatment}
                    selectedDate={selectedDate}
                    refetch={refetch}

                ></BookingModal>
            }

        </div>
    );

};

export default AvailavelAppointment;